import router from '@/router/index';
import { requestRoot } from '@/axios';

const state = {
  config: null,
  masteredGames: {},
  allAssignmentsByDay: null,
  currentAssignment: null,
  nextGame: null,
  reRenderGame: 0,
};

const getters = {
  getGameConfig: state => state.config,
  getAllAssignmentsByDay: state => state.allAssignmentsByDay,
  getCurrentAssignment: state => state.currentAssignment,
  getNextGame: state => state.nextGame,
  getReRenderGame: state => state.reRenderGame,
};
const actions = {
  setGameConfig({ commit }, config) {
    commit('SET_GAME_CONFIG', config);
  },
  reRenderGame({ commit }) {
    commit('RE_RENDER_GAME');
  },
  runALI({ rootGetters, dispatch }) {
    const childID = rootGetters['children/activeChildProfile'].id;

    return requestRoot.get(`/ali/${childID}`)
      .then(({ data }) => {
        if (data && data.id) {
          localStorage.setItem('ALI', true);
          dispatch('setGameConfig', data.sets[0] || null);
          router.push({ name: 'game', params: { id: data.id } });
        } else {
          router.push({ name: 'games' });
        }
      })
      .catch((err) => {
        console.error(err);
        router.push({ name: 'games' });
      });
  },
};
const mutations = {
  SET_GAME_CONFIG(state, config) {
    state.config = config;
  },
  RE_RENDER_GAME(state) {
    state.reRenderGame += 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
